import { ref } from "vue";

/**
 * Encapsulates ICP picker state and selection logic for AI Reply / AI Follow-up / AI Compose buttons.
 *
 * When there are 2+ ICPs, shows a picker. When there's 0-1 ICPs, auto-selects.
 *
 * @param onSelect - Callback receiving (mode, icpId) when an ICP is selected.
 */
export function useIcpPicker(
  onSelect: (mode: "reply" | "followup" | "compose", icpId?: string) => void
) {
  const showIcpPicker = ref(false);
  const icpPickerMode = ref<"reply" | "followup" | "compose" | null>(null);

  function triggerAiAction(
    mode: "reply" | "followup" | "compose",
    icps?: Array<{ id: string; name: string; isDefault?: boolean }>
  ) {
    if (icps && icps.length > 1) {
      icpPickerMode.value = mode;
      showIcpPicker.value = true;
    } else {
      onSelect(mode, icps?.[0]?.id);
    }
  }

  function selectIcp(icpId: string) {
    const mode = icpPickerMode.value;
    dismissIcpPicker();
    if (mode) onSelect(mode, icpId);
  }

  function dismissIcpPicker() {
    showIcpPicker.value = false;
    icpPickerMode.value = null;
  }

  return {
    showIcpPicker,
    icpPickerMode,
    triggerAiAction,
    selectIcp,
    dismissIcpPicker,
  };
}
